/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Moment_LeftInputs */

const en_directory_comparison_product_hunt_rows_moment_left = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Moment_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongoing product discovery`)
};

const zh_directory_comparison_product_hunt_rows_moment_left = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Moment_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`持续的产品发现`)
};

/**
* | output |
* | --- |
* | "Ongoing product discovery" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Moment_LeftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_moment_left = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Moment_LeftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Moment_LeftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_moment_left(inputs)
	return zh_directory_comparison_product_hunt_rows_moment_left(inputs)
});
export { directory_comparison_product_hunt_rows_moment_left as "directory.comparison.product_hunt.rows.moment.left" }